// Constants.ts - Constants Module
// (c) Marco Vieth, 2023
// https://benchmarko.github.io/CPCBasicTS/
//

export const enum ViewID { // eslint-disable-line no-shadow
	arrayBoundsInput = "arrayBoundsInput",
	autorunInput = "autorunInput",
	basicVersionSelect = "basicVersionSelect",
	canvasTypeSelect = "canvasTypeSelect",
	clearInputButton = "clearInputButton",
	consoleLogArea = "consoleLogArea",
	consoleLogText = "consoleLogText",
	continueButton = "continueButton",
	copyTextButton = "copyTextButton",
	cpcArea = "cpcArea",
	cpcCanvas = "cpcCanvas",
	databaseSelect = "databaseSelect",
	debugInput = "debugInput",
	directorySelect = "directorySelect",
	disassArea = "disassArea",
	disassInput = "disassInput",
	disassText = "disassText",
	downloadButton = "downloadButton",
	dropZone = "dropZone",
	enterButton = "enterButton",
	exampleSelect = "exampleSelect",
	exportArea = "exportArea",
	exportButton = "exportButton",
	exportBase64Input = "exportBase64Input",
	exportDSKInput = "exportDSKInput",
	exportDSKFormatSelect = "exportDSKFormatSelect",
	exportDSKStripEmptyInput = "exportDSKStripEmptyInput",
	exportFileSelect = "exportFileSelect",
	exportTokenizedInput = "exportTokenizedInput",
	fileInput = "fileInput",
	fullscreenButton = "fullscreenButton",
	galleryArea = "galleryArea",
	galleryAreaItems = "galleryAreaItems",
	galleryButton = "galleryButton",
	galleryItem = "galleryItem",
	helpButton = "helpButton",
	implicitLinesInput = "implicitLinesInput",
	inp2Area = "inp2Area",
	inp2Text = "inp2Text",
	inputArea = "inputArea",
	inputText = "inputText",
	integerOverflowInput = "integerOverflowInput",
	kbdAlpha = "kbdAlpha",
	kbdArea = "kbdArea",
	kbdAreaInner = "kbdAreaInner",
	kbdLayoutSelect = "kbdLayoutSelect",
	kbdNum = "kbdNum",
	lineNumberAddButton = "lineNumberAddButton",
	lineNumberRemoveButton = "lineNumberRemoveButton",
	linesOnLoadInput = "linesOnLoadInput",
	mainArea = "mainArea",
	moreArea = "moreArea",
	moreButton = "moreButton",
	dragElementsInput = "dragElementsInput",
	noCanvas = "noCanvas",
	outputArea = "outputArea",
	outputText = "outputText",
	pageBody = "pageBody",
	paletteSelect = "paletteSelect",
	parseButton = "parseButton",
	parseRunButton = "parseRunButton",
	prettyArea = "prettyArea",
	prettyBracketsInput = "prettyBracketsInput",
	prettyButton = "prettyButton",
	prettyColonsInput = "prettyColonsInput",
	prettyLowercaseVarsInput = "prettyLowercaseVarsInput",
	prettyPopoverButton = "prettyPopoverButton",
	prettySpaceInput = "prettySpaceInput",
	redoButton = "redoButton",
	redoButton2 = "redoButton2",
	renumArea = "renumArea",
	renumButton = "renumButton",
	renumKeepInput = "renumKeepInput",
	renumNewInput = "renumNewInput",
	renumPopoverButton = "renumPopoverButton",
	renumStartInput = "renumStartInput",
	renumStepInput = "renumStepInput",
	resetButton = "resetButton",
	resultArea = "resultArea",
	resultText = "resultText",
	runButton = "runButton",
	screenshotButton = "screenshotButton",
	screenshotLink = "screenshotLink",
	selectDataFilesInput = "selectDataFilesInput",
	settingsArea = "settingsArea",
	settingsButton = "settingsButton",
	showConsoleLogInput = "showConsoleLogInput",
	showCpcInput = "showCpcInput",
	showDisassInput = "showDisassInput",
	showInp2Input = "showInp2Input",
	showInputInput = "showInputInput",
	showKbdInput = "showKbdInput",
	showOutputInput = "showOutputInput",
	showResultInput = "showResultInput",
	showVariableInput = "showVariableInput",
	soundInput = "soundInput",
	speedInput = "speedInput",
	stopButton = "stopButton",
	traceInput = "traceInput",
	textCanvasDiv = "textCanvasDiv",
	textText = "textText",
	undoButton = "undoButton",
	undoButton2 = "undoButton2",
	variableArea = "variableArea",
	varSelect = "varSelect",
	varText = "varText",
	userKeys = "userKeys",
	viewArea = "viewArea",
	viewButton = "viewButton",
	window = "window" // for window.document
}
